module.exports = __webpack_public_path__ + "img/wzf_header.c6aa4b22.png";